<template>
    <div class="page-pianos-detail">
        <b-container fluid>
            <b-row>
                <b-col xs="12" md="6" class="main-image-slide mb-3 p-0">
                    <b-carousel controls
                                indicators
                                v-model="slide"
                                :interval="0"
                                align-v="center"
                                background="#333333">
                        <b-carousel-slide v-for="image in piano.photos"
                                          :key="image.id">
                            <img slot="img"
                                 class="d-block img-fluid"
                                 :src="image.url"
                                 :alt="piano"
                                 @click="showImagesModal(image)">
                        </b-carousel-slide>
                    </b-carousel>

                    <b-container fluid class="text-center">
                        <b-row>
                            <b-col cols="6" class="p-0">
                                <a href class="d-block p-2 image-tab" @click.prevent="showImagesModal">
                                    Photos
                                    <i class="fa fa-photo"></i>
                                </a>
                            </b-col>
                            <b-col cols="6" class="p-0">
                                <a href class="d-block p-2 video-tab" @click.prevent="showVideoModal">
                                    Video
                                    <i class="fa fa-video-camera"></i>
                                </a>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-col>

                <b-col xs="12" md="6" class="action-links">
                    <div class="mb-3 text-center">
                        <b-row>
                            <b-col class="detail-nav-link">
                                <a href v-b-modal.contact-modal @click.prevent>
                                    <i class="fa fa-envelope"></i><br>Contact
                                </a>
                            </b-col>
                            <b-col class="detail-nav-link">
                                <router-link to="/">
                                    <i class="fa fa-th"></i><br>Gallery
                                </router-link>
                            </b-col>
                            <b-col class="detail-nav-link">
                                <a href @click.prevent="addToFavorites" v-if="!isFavorite">
                                    <i class="fa fa-heart-o"></i><br>Favorite
                                </a>

                                <a href @click.prevent="removeFromFavorites" v-if="isFavorite">
                                    <i class="fa fa-heart" style="color: red;"></i><br>Favorite
                                </a>
                            </b-col>
                        </b-row>
                    </div>

                    <table class="table specs-table">
                        <colgroup>
                            <col style="width: 50%">
                            <col style="width: 50%">
                        </colgroup>
                        <thead>
                        <tr class="specs-table-header">
                            <th colspan="2" class="text-center">{{ piano.manufacturer }}</th>
                        </tr>
                        <tr class="specs-table-subheader text-center">
                            <th>{{ piano.model || piano.name }}</th>
                            <th v-if="piano.price">{{ parseInt(piano.price) ? '$' + piano.price : piano.price }}</th>
                            <th v-if="!piano.price">Contact Us</th>
                        </tr>
                        </thead>
                        <tr>
                            <td>Type: {{ piano.type }}</td>
                            <td>Size: {{ piano.size }}</td>
                        </tr>
                        <tr>
                            <td>Finish: {{ piano.finish }}</td>
                            <td>Style: {{ piano.style }}</td>
                        </tr>
                        <tr>
                            <td>Year: {{ piano.year }}</td>
                            <td>Serial No.: {{ piano.serial }}</td>
                        </tr>
                    </table>

                    <div v-if="piano.call_to_action" class="call-to-action-row">
                        {{ piano.call_to_action }}
                    </div>

                    <div class="piano-description-container" style="white-space: pre-line;text-align: left">{{ piano.description }}</div>
                </b-col>
            </b-row>
        </b-container>

        <b-modal ref="pianoImagesModal" hide-footer hide-header size="lg" class="piano-images-modal">
            <button type="button" aria-label="Close" class="close" @click="hideImagesModal">×</button>
            <div>
                <b-carousel controls
                            indicators
                            :interval="0"
                            background="#333333">
                    <!-- Text slides with image -->
                    <b-carousel-slide v-for="image in piano.photos"
                                      :key="image.id">
                        <img slot="img" class="d-block img-fluid"
                             :src="image.url"
                             :alt="piano"
                             @click="showImagesModal(image)">
                    </b-carousel-slide>
                </b-carousel>
            </div>
        </b-modal>

        <b-modal ref="pianoVideoModal" hide-footer hide-header size="lg">
            <div class="piano-video-container">
                <h1 class="text-center" v-if="!piano.video">No video.</h1>
                <video v-if="piano.video" class="piano-video" controls :src="piano.video" style="max-width: 100%;"></video>
            </div>
        </b-modal>

        <b-modal id="contact-modal" title="Contact" ref="contactModal">
            <form action="/contact" method="post" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)">
                <div v-if="piano.location">
                    <p class="mb-0"><strong>Piano is located at</strong></p>
                    <p>
                        {{ piano.location.name }}<br>
                        {{ piano.location.address }} {{ piano.location.address2}}<br>
                        {{ piano.location.city }}, {{ piano.location.state }} {{ piano.location.zip }}<br>
                    </p>
                </div>

                <p>Your information:</p>

                <div class="form-group">
                    <label for="name" class="sr-only">Name</label>
                    <input type="text" class="form-control" id="name" v-model="form.data.name" placeholder="* Full Name">
                    <span class="help-blog text-danger" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
                </div>
                <div class="form-group">
                    <label for="email" class="sr-only">Email</label>
                    <input type="email" class="form-control" id="email" v-model="form.data.email" placeholder="* Email">
                    <span class="help-blog text-danger" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></span>
                </div>
                <div class="form-group">
                    <label for="phone_number" class="sr-only">Phone #</label>
                    <input type="text" class="form-control" id="phone_number" v-model="form.data.phone_number" placeholder="* Phone #">
                    <span class="help-blog text-danger" v-if="form.errors.has('phone_number')" v-text="form.errors.get('phone_number')"></span>
                </div>
                <div class="form-group row" v-if="$store.state.locations.length === 0">
                    <div class="col-4">
                        <label for="city" class="sr-only">City</label>
                        <input type="text" class="form-control" id="city" v-model="form.data.city" placeholder="City (optional)">
                        <span class="help-blog text-danger" v-if="form.errors.has('city')" v-text="form.errors.get('city')"></span>
                    </div>
                    <div class="col-4">
                        <label for="state" class="sr-only">State</label>
                        <input type="text" class="form-control" id="state" v-model="form.data.state" placeholder="State (optional)">
                        <span class="help-blog text-danger" v-if="form.errors.has('state')" v-text="form.errors.get('state')"></span>
                    </div>
                    <div class="col-4">
                        <label for="zip" class="sr-only">Zip</label>
                        <input type="text" class="form-control" id="zip" v-model="form.data.zip" placeholder="* Zip">
                        <span class="help-blog text-danger" v-if="form.errors.has('zip')" v-text="form.errors.get('zip')"></span>
                    </div>
                </div>
                <div class="form-group" v-else>
                    <label for="location_id" class="sr-only">Location</label>
                    <select name="location_id" id="location_id" class="form-control" v-model="form.data.location_id">
                        <option :value="null">* Choose a location near you</option>
                        <option v-for="location in $store.state.locations" :value="location.id" :key="location.id">
                            {{ location.city }}, {{ location.state }}
                        </option>
                    </select>
                </div>

                <p>Message</p>

                <div class="form-group">
                    <label for="subject" class="sr-only">Subject</label>
                    <input type="text" class="form-control" id="subject" v-model="form.data.subject" placeholder="* Subject">
                    <span class="help-blog text-danger" v-if="form.errors.has('subject')" v-text="form.errors.get('subject')"></span>
                </div>
                <div class="form-group">
                    <label for="message" class="sr-only">Message</label>
                    <textarea class="form-control" id="message" v-model="form.data.message" placeholder="Message (optional)" rows="4"></textarea>
                    <span class="help-blog text-danger" v-if="form.errors.has('message')" v-text="form.errors.get('message')"></span>
                </div>

                <p>Fields marked with * are required.</p>
            </form>

            <div slot="modal-footer">
                <button class="btn btn-default" @click="$refs.contactModal.hide()">Cancel</button>
                <button class="btn btn-primary" @click="onSubmit">Submit</button>
            </div>
        </b-modal>

        <!--Confirmation modal-->
        <b-modal id="submission-confirm-modal" ref="submissionConfirmModal" title="Contact Submission Sent.">
            <p clas="my-4">We will get back to you as soon as possible!</p>

            <div slot="modal-footer">
                <button class="btn btn-primary" @click="$refs.submissionConfirmModal.hide()">OK</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Form from '../utils/Form'
import api from '../api'

export default {
    data() {
        let piano

        if (this.$store.state.previewPiano) {
            piano = this.$store.state.previewPiano
        }
        else {
            const pianoId = parseInt(this.$route.params.id)

            piano = this.$store.state.pianos.find(piano => piano.id === pianoId)
        }

        return {
            piano,
            slide: 0,
            isFavorite: localStorage.favoritePianos && localStorage.favoritePianos.indexOf(piano.id) > -1,
            form: new Form({
                address_type: this.$store.state.locations.length > 0 ? 'location_id' : 'city-state-zip',
                id: piano.id,
                location_id: null,
                name: null,
                email: null,
                phone_number: null,
                city: null,
                state: null,
                zip: null,
                subject: null,
                message: null,
            }),
        }
    },


    methods: {
        onSubmit() {
            api.post('/contact', this.form.data).then(() => {
                this.form.reset()
                this.$refs.contactModal.hide()
                this.$refs.submissionConfirmModal.show()
            }).catch((error) => {
                if (error.response.status) {
                    this.form.errors.record(error.response.data.errors)
                }
            })
        },


        addToFavorites() {
            this.isFavorite = true
            let favoritePianos = this._getLocalStorageFavoritePianos()

            if (favoritePianos.indexOf(this.piano.id) === -1) {
                favoritePianos.push(this.piano.id)

                localStorage.favoritePianos = favoritePianos
            }
        },


        removeFromFavorites() {
            this.isFavorite = false

            let favoritePianos = this._getLocalStorageFavoritePianos()

            const index = favoritePianos.indexOf(this.piano.id)

            if (index > -1) {
                favoritePianos.splice(index, 1)

                localStorage.favoritePianos = favoritePianos
            }
        },


        showImagesModal() {
            this.$refs.pianoImagesModal.show()
        },


        hideImagesModal() {
            this.$refs.pianoImagesModal.hide()
        },


        showVideoModal() {
            this.$refs.pianoVideoModal.show()
        },


        hideVideoModal() {
            this.$refs.pianoVideoModal.hide()
        },


        _getLocalStorageFavoritePianos() {
            let favoritePianos

            if (localStorage.favoritePianos) {
                favoritePianos = localStorage.favoritePianos.split(',').map(n => parseInt(n))
            }
            else {
                favoritePianos = []
            }
            return favoritePianos
        },
    },
    mounted() {
        //
    },
}
</script>

<style type="text/scss" lang="scss">
/*there is an issue with the style loader so we can't include the styles here, go to styles/_pages.scss instead*/
</style>



// WEBPACK FOOTER //
// src/pages/PianoDetails.vue